import { gql } from '@apollo/client';

export const UPSERT_APPOINTMENT = gql`
  mutation upsertAppointment($input: UpsertAppointmentInput!) {
    appointment: upsertAppointment(input: $input) {
      id
    }
  }
`;
